export default __webpack_public_path__ + "static/media/bankaltimtara.45fd4a5b.jpeg";